<template>
  <div class="cropperWrap">
    <div class="white">
      <div class="content">
        <img ref="image" :src="src" />
      </div>
      <div class="wrapppCroppImage">
        <img :src="destination" />
      </div>
      <div class="wrapButton">
        <div>
          <p v-if="imageSize">
            {{ $t('details.details.size') + '' + imageSize }} kb
          </p>
          <p v-if="imageSize">{{ $t('details.details.imageSizeError') }}</p>
        </div>
        <div class="roundBtn">
          <div class="btn btnC" @click="cropp">{{ $t('main.cropp') }}</div>
          <div class="btn inv btnC" @click="giveUp">
            {{ $t('main.giveUp1') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cropper from 'cropperjs'
import helper from '@/js/helper.js'

export default {
  name: 'ImageCropper',
  props: ['src', 'extension'],
  data () {
    return {
      cropper: {},
      destination: {},
      image: {},
      msg: false,
      imageSize: ''
    }
  },
  mounted () {
    // console.log('src ' + this.src)
    this.image = this.$refs.image
    this.cropper = new Cropper(this.image, {
      zoomable: false,
      scalable: false,
      aspectRatio: 4 / 3,
      minCropBoxWidth: 4,
      minCropBoxHeight: 3,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: 'high',
      crop: () => {
        const canvas = this.cropper.getCroppedCanvas({
          fillColor: '#fff'
        })
        this.destination = canvas.toDataURL(
          this.extension !== '' ? this.extension : 'image/png'
        )
      },
      cropmove: event => {
        // console.log(event)
        // console.log(helper.base64toFile(this.destination, 'picName').size)
      },
      cropend: event => {
        this.imageSize = Math.round(
          helper.base64toFile(this.destination, 'picName').size * 0.001
        ) // size / 1024
        this.imageSize = Math.round(
          helper.base64toFile(this.destination, 'picName').size / 1024
        )
        // console.log(event)
        // console.log(helper.base64toFile(this.destination, 'picName').size)
      }
    })
    //  this.imageSize = Math.round(helper.base64toFile(this.destination, 'picName').size * 0.001)
  },
  methods: {
    cropp () {
      // console.log(this.destination)
      if (helper.base64toFile(this.destination, 'picName').size > 409600) {
        // this.imageSize = Math.round(helper.base64toFile(this.destination, 'picName').size * 0.001)
        this.imageSize = Math.round(
          helper.base64toFile(this.destination, 'picName').size / 1024
        )
        this.msg = true
        return
      }
      this.$emit('cropp', this.destination)
    },
    giveUp () {
      this.image = {}
      this.destination = {}
      this.msg = false
      this.imageSize = ''
      this.$emit('giveup')
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/btnStyles';
.cropperWrap {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.555);
  overflow: auto;
  .white {
    background: white;
    width: 620px;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .content {
    z-index: 10005;
    background: white;
    width: 600px;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .wrapppCroppImage {
    padding: 10px;
    box-sizing: border-box;
    // background:white;
    width: 600px;
    display: flex;
    justify-content: center;
    img {
      background: white;
      border: 1px solid rgba(71, 71, 71, 0.616);
      width: 250px;
    }
  }
  .wrapButton {
    width: calc(100% - 20px);
    box-sizing: border-box;
    border-top: 2px solid rgba(71, 71, 71, 0.322);
    display: flex;
    // justify-content: flex-end !important;7
    justify-content: space-between;
    margin: 0 10px;
    padding: 10px 0;
    .roundBtn {
      display: flex;
    }
    .btnC {
      margin-left: 10px;
    }
  }
  .wrapButton > div > p {
    margin-top: 0;
    text-align: left;
  }
}

@media only screen and (max-width: 768px) {
  .cropperWrap {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    .white {
      background: white;
      width: 90vw;
      height: 90%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start !important;
      height: 80vh;
      overflow: auto;
    }
    .content {
      min-width: 50%;
      min-height: 50%;
      max-width: 90vw;
    }
    .wrapppCroppImage {
      margin-top: 10px;
      padding: 10px;
      box-sizing: border-box;
      // background:white;
      width: 90vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 250px;
      }
    }
    .wrapButton {
      .btnC {
        margin-left: 0px;
        margin-top: 10px;
      }
      .btnC:nth-of-type(2) {
        margin-left: 10px;
      }
    }
  }
}
</style>
